let _locale = "nb-NO";

export function setDateLocale(locale: string) {
  _locale = locale;
}

export function formatDate(date: string | Date | number | null | undefined) {
  if (!date) return "";
  if (date instanceof Date) return date.toLocaleDateString(_locale);
  return new Date(date).toLocaleDateString(_locale);
}
